import { useQuery } from "@tanstack/react-query";
import { getLastOrderDate } from "./customerSummariesApi";

export const useLastOrderDate = (customerId: string) =>
  useQuery({
    queryKey: ["customers", customerId, "last-order-date"],
    queryFn: ({ signal }) => getLastOrderDate(customerId, signal),
  });
